/** 30 - padding bottom
 * 32 - pagination button height
 * 32 - gap between pagination buttons and table
 */
export const HEIGTH_UNDER_TABLE = 94;
export const BASIC_CELL_HEIGHT = 82;
export const ITEMS_ON_PAGE = 50;
export const MAX_PAGINATION_BUTTONS = 5;
